import React, { useCallback } from "react";
import { IconButton, TextField } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import type { FC, ChangeEvent, MouseEvent } from "react";
import { useStyles } from "./Counter.styles";
import type { ICounterProps } from "./Counter.types";

const MIN_VALUE = 0;

export const Counter: FC<ICounterProps> = (props) => {
  const classes = useStyles();
  const { onChange, disabled, max, value } = props;
  const finalValue = value < MIN_VALUE ? MIN_VALUE : value;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const targetValue = Number(event.target.value);
      if (targetValue > max) {
        onChange(max);
      } else if (targetValue < MIN_VALUE) {
        onChange(MIN_VALUE);
      } else {
        onChange(targetValue);
      }
    },
    [onChange, max]
  );

  const handleIncrement = useCallback(
    (event: MouseEvent<{}>) => {
      const nextValue = finalValue + 1;
      onChange(nextValue > max ? max : nextValue);
    },
    [finalValue, max, onChange]
  );

  const handleDecrement = useCallback(
    (event: MouseEvent<{}>) => {
      const nextValue = finalValue - 1;
      onChange(nextValue < MIN_VALUE ? MIN_VALUE : nextValue);
    },
    [finalValue, onChange]
  );

  return (
    <div className={classes.root}>
      <span className={classes.label}>Last:</span>

      <IconButton aria-label="decrement" size="small" color="primary" onClick={handleDecrement} disabled={disabled}>
        <RemoveIcon fontSize="inherit" />
      </IconButton>
      <TextField
        disabled={disabled}
        type="number"
        value={finalValue === 0 ? "" : String(finalValue)}
        InputProps={{ inputProps: { min: MIN_VALUE, max, step: 1, className: classes.input } }}
        onChange={handleChange}
      />
      <IconButton aria-label="increment" size="small" color="primary" onClick={handleIncrement} disabled={disabled}>
        <AddIcon fontSize="inherit" />
      </IconButton>
    </div>
  );
};
